import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { EstoqueConsolidadoService } from 'src/app/services/clique-retire/estoque-consolidado/estoque-consolidado.service';
import { ProductInventory, InventoryKit, InventoryTimeline } from 'src/app/@shared/models/estoque-consolidado.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Branch } from 'src/app/@shared/models/filial.model';
import { FilialService } from 'src/app/services/filial/filial.service';
import { CABECALHO, PRODUTO } from 'src/app/@shared/models/dados-fixos';
import { HttpResponse } from '@angular/common/http';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-estoque-consolidado',
  templateUrl: './estoque-consolidado.component.html',
  styleUrls: ['./estoque-consolidado.component.scss']
})
export class EstoqueConsolidadoComponent implements OnInit {
  usuario = StorageService.getPerfilUsuario();
  public isLoading = true;
  public customer: string = CABECALHO.cliente;
  public product: string = PRODUTO.nome;
  public filterForm: FormGroup = new FormGroup({
    branch: new FormControl(
      this.usuario.perfilacessotipo === 3 && this.usuario.filialid
        ? { value: this.usuario.filialid, disabled: true }
        : { value: 'Todas', disabled: false }
    )
  });
  get filial() { return this.filterForm.get('branch').value; }

  public branches: Branch[];
  public paging = { index: 0, size: 10, length: 0 };
  public displayedColumns: string[] = ['filial', 'modeloKit', 'quantidade', 'transitoria', 'action'];
  public estoqueConsolidado: MatTableDataSource<ProductInventory> = new MatTableDataSource<ProductInventory>();

  constructor(
    public dialog: MatDialog,
    public branchSvc: FilialService,
    public inventSvc: EstoqueConsolidadoService
  ) { }

  ngOnInit() {
    this.getBranches();
    this.listarEstoqueConsolidado();
  }

  public getBranches() {
    this.branchSvc.getList().subscribe(res => this.branches = res);
  }

  public listarEstoqueConsolidado() {
    this.isLoading = true;
    this.estoqueConsolidado.data = null;

    const obj = {
      filialId: this.filial === 'Todas' ? null : this.filial,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    };

    this.inventSvc.listarEstoqueConsolidado(obj).subscribe(
      (response: HttpResponse<ProductInventory[]>) => {
        this.estoqueConsolidado.data = response.body;
        if (response.body.length > 0) {
          this.paging.length = response.body[0].totalCount;
        }
        this.isLoading = false;
      }
    );
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.listarEstoqueConsolidado();
  }

  public getQuantity() {
    if (this.estoqueConsolidado.data) {
      return this.estoqueConsolidado.data.map(t => t.quantidade).reduce((acc, value) => acc + value, 0);
    }
    return null;
  }

  public getTransitory() {
    if (this.estoqueConsolidado.data) {
      return this.estoqueConsolidado.data.map(t => t.transitoria).reduce((acc, value) => acc + value, 0);
    }
    return null;
  }

  openKit(modeloId: number, filial: Branch): void {

    const kitRef = this.dialog.open(ModalKitComponent, {
      width: '1200px',
      data: { modeloId, filial }
    });

    kitRef.afterClosed().subscribe(result => { });
  }
}

// #region Modal Kit
@Component({
  selector: 'app-modal-kit',
  templateUrl: 'modal-kit.html',
})

export class ModalKitComponent implements OnInit {
  isLoading = true;
  paging = { index: 0, size: 5, length: 0 };
  displayedColumnsKit: string[] = [
    'situacao',
    'modeloKit',
    'numeroSequencial',
    'codigoBarra',
    'dataEntrada',
    'usuarioEntrada',
    'dataDevolucao',
    'usuarioDevolucao',
    'saidaTransitoria',
    'action'
  ];

  estoqueConsolidadoKit: MatTableDataSource<InventoryKit> = new MatTableDataSource<InventoryKit>();
  public filial: Branch;
  public modeloId: number;
  public statusCount: { cust: number, cons: number } = { cust: 0, cons: 0 };

  constructor(
    public dialog: MatDialog,
    public inventSvc: EstoqueConsolidadoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.filial = data.filial;
    this.modeloId = data.modeloId;
  }

  ngOnInit() {
    this.listarEstoqueConsolidadoDetalhe();
  }

  openLog(prePedidoId: number): void {
    const modalLog = this.dialog.open(ModalLogComponent, {
      width: '1100px',
      data: { prePedidoId }
    });
  }

  public listarEstoqueConsolidadoDetalhe(): void {
    this.isLoading = true;

    const obj = {
      modeloId: this.modeloId,
      filialId: this.filial.filialID,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    };

    this.inventSvc.listarEstoqueConsolidadoDetalhe(obj).subscribe(
      (response: HttpResponse<InventoryKit[]>) => {
        this.estoqueConsolidadoKit.data = response.body;
        if (response.body.length > 0) {
          this.paging.length = response.body[0].totalCount;
        }
        this.isLoading = false;

        this.statusCount = response.body.reduce((acc, v) => ({
          cust: acc.cust + (v.situacao === 'Custódia' ? 1 : 0),
          cons: acc.cons + (v.situacao === 'Consolidado' ? 1 : 0)
        }), { cust: 0, cons: 0 });
      }
    );
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.listarEstoqueConsolidadoDetalhe();
  }
}
// #endregion Modal Kit

// #region Modal Log
@Component({
  selector: 'app-modal-log',
  templateUrl: 'modal-log.html',
})

export class ModalLogComponent implements OnInit {
  isLoading = true;
  paging = { index: 0, size: 5, length: 0 };
  prePedidoId: number;
  displayedColumnsLog: string[] = ['evento', 'filialOrigem', 'data', 'usuario'];
  estoqueConsolidadoLog: MatTableDataSource<InventoryTimeline> = new MatTableDataSource<InventoryTimeline>();

  constructor(
    public dialogRef: MatDialogRef<ModalLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private inventSvc: EstoqueConsolidadoService
  ) {
    this.prePedidoId = data.prePedidoId;
  }

  ngOnInit() {
    this.listarEstoqueConsolidadoLinhaTempo();
  }

  public listarEstoqueConsolidadoLinhaTempo() {
    this.isLoading = true;

    const obj = {
      prePedidoId: this.prePedidoId,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    };

    this.inventSvc.listarEstoqueConsolidadoLinhaTempo(obj).subscribe(
      (response: HttpResponse<InventoryTimeline[]>) => {
        this.estoqueConsolidadoLog.data = response.body;
        if (response.body.length > 0) {
          this.paging.length = response.body[0].totalCount;
        }
        this.isLoading = false;
      });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.listarEstoqueConsolidadoLinhaTempo();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
// #endregion Modal Log
